import { plainToClass } from "class-transformer";
import { StudyListingDto } from "./studies.objects";
import { TableColumnVisibilityController, TableColumnGroup } from "../../../shared/scripts/table-column-visibility";
import { Unique } from "../../../shared/scripts/array-functions";
import { IFilter } from "../../../shared/scripts/filtering/filtering.entities";
import { InitializeFilterDropdown } from "../../../shared/scripts/filtering/filtering.utilities";

export class StudiesPage implements IFilter {
    studies: StudyListingDto[];
    dataTable: any;
    filterDropdownIds: string[];
    token: string;
    constructor(allStudiesJson: any) {
        $(() => {
            this.studies = plainToClass(StudyListingDto, <StudyListingDto[]>allStudiesJson);
            this.filterDropdownIds = [
                '#study-dropdown'
            ];
            this.token = document.querySelector('input[name="__RequestVerificationToken"]').getAttribute('value');
            this.initializeFilters();
            this.initializeTable();
            this.initializeModal();
        });
    }

    initializeFilters(): void {
        // Study filter
        let studyValues: string[] = this.studies.map(s => s.Name);
        InitializeFilterDropdown('#study-dropdown', Unique(studyValues, true, ["None Selected"]), this);
    }

    initializeTable(): void {
        this.dataTable = $('#studies-table').DataTable({
            dom: 'rtip',
            autoWidth: true,
            info: false,
            paging: false,
            search: true,
            scrollX: true,
            scrollY: '60vh',
            scrollCollapse: true,
            orderCellsTop: true,
            order: [[0, 'asc']], // Order by Site Number
            columns: [
                //{
                //    data: null,
                //    title: '<input type="checkbox" />',
                //    className: "ctms-table-col-check",
                //    orderable: false,
                //    render: function () {
                //        return '<input type="checkbox" />';
                //    }
                //},
                { data: "Name", title: "Study&nbsp;Name" },
                {
                    data: null,
                    title: "",
                    className: "ctms-table-col-actions",
                    orderable: false,
                    render: function (data, type, row) {
                        //    return '<button type="button" title="Edit"><i class="fa-solid fa-pencil" aria-hidden="true"></i></button>';
                        return `<a href="/secure/ctms/studies/study-details?id=${row.Id}" title="Edit"><i class="ctms-icon-pencil"></i></a>`;
                    }
                }
            ],
            data: this.studies
        });

        $('#custom-dt-search').on('input', function () {
            $('#studies-table').DataTable().search(String($(this).val() ?? '')).draw();
        });
        $('.ctms-icon-button[title="Clear Search"]').on('click', function () {
            $('#custom-dt-search').val('');
            $('#studies-table').DataTable().search('').draw();
        });
    }

    updateTable(matchingItems: StudyListingDto[]): void {
        this.dataTable.clear();
        this.dataTable.rows.add(matchingItems).draw();
    }

    triggerFilter(): void {
        //const selectedSite = this.getSelectedDropdownValues('#site-dropdown');
        const selectedStudy = this.getSelectedDropdownValues('#study-dropdown');
        //const selectedStatus = this.getSelectedDropdownValues('#status-dropdown');

        const matchingStudies: StudyListingDto[] = [];

        this.studies.forEach(item => {
            if (item.matchesFilter(
                //selectedSite,
                selectedStudy,
            //    selectedStatus
            )) {
                matchingStudies.push(item);
            }
        });

        this.updateTable(matchingStudies);
    }

    getSelectedDropdownValues(selectId: string): any {
        return $(selectId).val();
    }

    resetFilters(): void {
        this.filterDropdownIds.forEach((dropdownId: string) => {
            $(dropdownId).selectpicker('selectAll');
            $(dropdownId).selectpicker('refresh');
        });
        $('#custom-dt-search').val('');
        this.dataTable.search('').draw();
        this.updateTable(this.studies);
    }

    initializeModal() {
        $('#newStudyDialog').modal({
            backdrop: 'static',
            show: false,
        });

        // bind buttons
        $('#addStudyButton').on('click', () => {
            this.openAddModal();
        });

        $('#newStudyDialog .ctms-button-save').on('click', (e) => {
            const f = document.getElementById('studyDialogForm') as HTMLFormElement;

            if (f.checkValidity()) {
                $('#studyDialogForm').removeClass('ctms-invalid-form');

                $.ajax({
                    url: `/secure/ctms/studies/studies?handler=AddStudy`,
                    headers: { "RequestVerificationToken": this.token },
                    type: 'POST',
                    data: $('#newStudyDialog .ctms-field-submit').serialize(),
                    success: (resp) => {
                        // console.log(resp);

                        const newStudy = plainToClass(StudyListingDto, resp);

                        this.studies.push(newStudy);
                        this.resetFilters();

                        $('#newStudyDialog').modal('hide');
                    }
                });
            } else {
                $('#studyDialogForm').addClass('ctms-invalid-form');
            }

            e.preventDefault();
            e.stopPropagation();
        });

    }

    async openAddModal() {
        // reset form
        $('#newStudyDialog .ctms-field-submit').each((i, e) => {
            if (e.getAttribute('type') === 'text') {
                $(e).val('');
            }
            if (e.getAttribute('type') === 'checkbox') {
                $(e).prop('checked', false);
            }
        });

        // open modal
        $('#newStudyDialog').modal('show');

    }
}